


























































import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ProfileResponse } from '@/model/Profile';
import {
    EventResponse,
    InviteUserRequest,
    RemoveUserRequest,
} from '@/model/Event';
import EventEditorsTable from '@/components/event-editors/EventEditorsTable.vue';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import ToastVariant from '@/model/enums/toast/toast-variant';
import FormSelector from '@/components/form/FormSelector.vue';
import { FormItem } from '@/model/form/FormItem';

@Component({
    components: {
        EventEditorsTable,
        FormSelector,
    },
    computed: {
        ...mapGetters({
            getEvent: 'eventStorage/getEvent',
            getInvitableUsers: 'eventStorage/getInvitableUsers',
            getInvitedUsers: 'eventStorage/getInvitedUsers',
        }),
    },
    methods: {
        ...mapActions({
            fetchInvitableUsers: 'eventStorage/fetchInvitableUsers',
            fetchInvitedUsers: 'eventStorage/fetchInvitedUsers',
            fetchEventById: 'eventStorage/fetchEventById',
            inviteUser: 'eventStorage/inviteUser',
            removeUser: 'eventStorage/removeUser',
        }),
        ...mapMutations({
            setInvitableUsers: 'eventStorage/setInvitableUsers',
            setInvitedUsers: 'eventStorage/setInvitedUsers',
        }),
    },
})
export default class Events extends mixins(ToastMixin) {
    fetchInvitableUsers!: (id: number) => Promise<void | ProfileResponse[]>;

    fetchInvitedUsers!: (id: number) => Promise<void | ProfileResponse[]>;

    fetchEventById!: (id: number) => Promise<void | EventResponse>;

    inviteUser!: (inviteUserRequest: InviteUserRequest) => Promise<void>;

    removeUser!: (removeUserRequest: RemoveUserRequest) => Promise<void>;

    setInvitableUsers!: (setInvitableUsers: ProfileResponse[] | null) => void;

    setInvitedUsers!: (invitedUsers: ProfileResponse[] | null) => void;

    getInvitableUsers!: ProfileResponse[];

    getInvitedUsers!: ProfileResponse[];

    getEvent!: EventResponse | null;

    eventId: number = +this.$route.params.id;

    userId: number | null = null;

    loading = true;

    mounted(): void {
        this.fetchEventById(this.eventId)
            .then(() => {
                document.title = this.$t('navigation.pages.event-editors', {
                    eventName: `${this.getEvent?.name}`,
                }).toString();
            })
            .catch(() => {
                this.$router.push(`/event/${this.eventId}`);
            })
            .finally(() => {
                this.loading = false;
            });
        this.fetchInvitedUsers(this.eventId);
        this.fetchInvitableUsers(this.eventId);
    }

    destroyed(): void {
        this.setInvitableUsers(new Array<ProfileResponse>());
        this.setInvitedUsers(new Array<ProfileResponse>());
    }

    get getInvitableUsersAsOptions(): Array<FormItem> {
        return this.getInvitableUsers.map((user) => {
            return {
                id: user.id,
                value: user.id,
                name: `${user.firstName} ${user.lastName}`,
            };
        });
    }

    invite(): void {
        if (this.userId === null) {
            return;
        }
        this.loading = true;
        this.inviteUser({ eventId: this.eventId, userId: Number(this.userId) })
            .then(() => {
                this.fetchInvitedUsers(this.eventId);
                this.fetchInvitableUsers(this.eventId);
                this.showToast(
                    this.$t(
                        'event-editors.notification.invite.successful',
                    ).toString(),
                    this.$t(
                        'event-editors.notification.invite.title',
                    ).toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .finally(() => {
                this.loading = false;
                this.userId = null;
            });
    }

    onRemove(profileResponse: ProfileResponse): void {
        this.loading = true;
        this.removeUser({ eventId: this.eventId, userId: profileResponse.id })
            .then(() => {
                this.fetchInvitedUsers(this.eventId);
                this.fetchInvitableUsers(this.eventId);
                this.showToast(
                    this.$t('event-editors.notification.remove.successful', {
                        name: profileResponse.firstName,
                    }).toString(),
                    this.$t(
                        'event-editors.notification.remove.title',
                    ).toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .finally(() => {
                this.loading = false;
                this.userId = null;
            });
    }
}
